<!--模板-->
<template>
  <div id="orderAdd">
    <!-- ***预约步骤 -->
    <div class="sec_order_step clearfix">
      <div class="order-step-inner mid">
        <ul>
          <li><span class="s1">STEP 01</span><span class="s2">选择陪陪服务者</span></li>
          <li class="arrow"></li>
          <li class="on"><span class="s1">STEP 02</span><span class="s2">提交服务项需求</span></li>
          <li class="arrow"></li>
          <li><span class="s1">STEP 03</span><span class="s2">支付预定金</span></li>
          <li class="arrow"></li>
          <li><span class="s1">STEP 04</span><span class="s2">等待陪陪确认</span></li>
        </ul>
      </div>
    </div>
    <!-- ***预约流程(陪行) -->
    <div class="sec_guide_container pb--50 mid--1150 clearfix">
      <div class="lay-gd-main lay-gd-main2 fl">
        <!-- //step 02(填写申请)-->
        <div class="pg-orderStep-zone">
          <form action="#" method="post" id="px_order_form">
            <!-- 基础信息-->
            <div class="base_info clearfix">
              <h3 class="tit">基础信息</h3>
              <div class="cont">
                <div class="row clearfix">
                  <label class="lbl">服务城市</label>
                  <div class="box fl" style="display: flex;align-items: center">
                    <div class="city_list">
                      <a>{{Serves.serveCityStr}}</a>
                    </div>
                    <!--<div class="city_add" >-->
                    <!--&lt;!&ndash;<input type="text" name="addcity" placeholder="添加城市" />&ndash;&gt;-->
                    <!--<span>(“陪陪服务者”目前能够提供服务的城市，请明确！)</span>-->
                    <!--</div>-->
                  </div>
                </div>
                <div class="row clearfix">
                  <label class="lbl">服务时间</label>
                  <div class="box ">
                    <el-date-picker v-model="startTimeData" type="datetimerange" range-separator="至"     format="yyyy-MM-dd HH:mm" @change="TimeDataBtn" start-placeholder="开始日期" value-format="timestamp" :default-time="['18:00:00', '23:59:59']" end-placeholder="结束日期">
                    </el-date-picker>
                    <!--<input class="ipt-text start_timepicker" name="start_time" type="text" placeholder="出发日期" />-->
                    <!--<em class="split">~</em>-->
                    <!--<input class="ipt-text end_timepicker" name="end_time" type="text" placeholder="结束日期" />-->
                    <em class="split ml--10">(服务<b>{{setListData.length}}</b>天)
                      <!-- (服务{{setListData.length}}次) -->
                      </em>
                  </div>
                </div>
                <div class="row clearfix">
                  <label class="lbl">服务人数</label>
                  <div class="box fl">
                    <!--<span>成人</span>-->
                    <el-input-number style="display: inline-block" v-model="nameNumber" :min="1" :max="10" label="成人"></el-input-number><span style="margin-left:10px;font-size:15px;">（人）</span>
                    <!--<span style="margin-left: 30px">儿童</span>-->
                    <!--<el-input-number style="display: inline-block" v-model="nameNumberSm"   :min="0" :max="10" label="儿童"></el-input-number>-->
                    <!-- （注：如有儿童、孕妇请另行备注） -->
                  </div>
                </div>
                <div class="row clearfix">
                  <label class="lbl">服务次数</label>
                  <div class="box fl">
                    <el-input-number style="display: inline-block" v-model="serveNum" :min="1" :max="999" label="次数" @change="numChange"></el-input-number>
                    <span style="margin-left:10px;font-size:15px;">（次）</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 行程需求-->
            <div class="trip_info clearfix">
              <h3 class="tit">行程需求</h3>
              <div class="cont clearfix">
                 <p style="text-align:center;font-size:18px;padding:30px 0 20px 0;color:#f60;">（{{startTimeData[0] | time}} - 开始服务）</p>

                <div class="t_head clearfix">
                  <div class="col1">服务次数</div>
                  <div class="col2">服务类型</div>
                  <div class="col3">选择所需服务(可更改)</div>
                  <div class="col4">提供的服务城市</div>
                </div>
                <div class="t_body" v-if="ServesList">
                 <div class="t_row" v-for="(item,index) of setListData" :key="index">
                    <div class="col_collpse clearfix">
                      <span class="fl">D.{{index+1}}</span>
                      <span class="fr"><em class="tag"><i><b>{{PriceGet(item.code)}}</b>元 / {{PriceNamGet(item.code)}}</i></em></span>
                    </div>
                    <div style="display: flex;align-items: center">
                      <div class="col1">
                        第{{index+1}}次
                      </div>
                      <div class="col2">
                        <span>[{{textxGet(item.code)}}]</span>
                      </div>
                      <div class="col3">
                        <el-select v-model="item.code" placeholder="请选择服务">
                          <el-option v-for="key in ServesList" :key="key.code" :label="key.title" :value="key.code">
                          </el-option>
                        </el-select>
                      </div>
                      <div class="col2">
                        <span>{{cityGet(item.code)}}</span>
                      </div>
                      <!--<div class="col4">-->
                      <!--<textarea name="contents" placeholder="在此处，可备注您的特殊需求~ 无需求，可不填"></textarea>-->
                      <!--</div>-->
                    </div>
                    <div class="list_del" v-if="index != 0">
                      <span @click="delList(index)">㊀删除此条</span>
                    </div>
                  </div>
                  <p class="addList"><span @click="addList()">㊉ 再新增一次</span></p>
                  <div class="t_total"><span>服务<b class="c--f60">{{serveNum}}次</b>，共计：<b class="c--f60">{{moneyCount()}}元 </b>（CNY）</span></div>
                </div>
              </div>
            </div>
            <!--备注-->
            <div class="valid_tel clearfix" style="margin-top: 50px">
              <h3 class="tit">订单备注:</h3>
              <div class="cont">
                <textarea v-model="remark" style="font-size: 18px;color: #666666;width: 500px;height: 100px;padding: 10px" placeholder="如有特殊要求，在此处可备注~ 无需求，可不填"></textarea>
              </div>
            </div>
            <!-- 验证手机-->
            <div class="valid_tel clearfix" style="margin-top: 50px">
              <h3 class="tit">请填写（联系人手机号）:</h3>
              <div class="cont">
                <p class="tips">我们将维护您的隐私安全，只有当预订成功时，双方才能看见您的联系方式！</p>
                <div class="validCode">
                  <div class="box fl" style="font-size: 18px;">
                    电话：
                    <input class="ipt-text" v-model="iphone" name="phoneNum" type="text" placeholder="请输入手机号" /> (请仔细填写，避免无法联系到您~)
                  </div>
                  <div class="box fl" style="font-size: 18px;margin-top: 10px">
                    微信：
                    <input class="ipt-text" v-model="wechat" name="phoneNum" type="text" placeholder="请填写微信号" /> (选填~)
                  </div>
                  <!--<div class="box fl">-->
                  <!--<button class="sendCode">发送验证码</button>-->
                  <!--</div>-->
                </div>
              </div>
            </div>
            <div class="submit_order fl">
              <div class="submit-btn" @click="orderAdd">提交需求订单</div>
            </div>
          </form>
        </div>
      </div>
      <div class="lay-gd-side fr">
        <div class="i-service i-service2">
          <div class="service-ct clearfix">
            <div class="my-serv">
              <h2>Ta提供的所有服务</h2>
              <div class="ct" v-for="(item,index) of ServesList" :key="index" @click="$router.push('/homePage?nameCode=' +  $route.query.nameCode +'&nameService=' + item.code)">
                <p class="p1">{{item.title}}</p>
                <p class="p2">[{{item.pushTypeStr}}] CNY <b class="c--f60">{{item.pushPrice}}元</b> /{{item.servePriceName}}</p>
                <p style="text-align: right;color: #565555;padding: 0 10px 10px 0">查看详情>></p>
              </div>
            </div>
          </div>
          <!-- //我的服务档期-->
          <div class="serv-date" style="margin:30px auto 0;">
            <h2 style="background:#eee;border:1px solid #ddd;color:#333;font-size:16px;font-weight:700;margin:0 0 -1px 9px;text-align:center;height:40px;line-height:40px;width:340px;">服务者-档期日历（星期X）</h2>
            <div id="CalendarMain">
              <div id="context">
                <div class="week" v-if="Serves && Serves.serveTimeInterval">
                  <h3 :class="Serves.serveTimeInterval.indexOf('周一') > -1 ?  '' : 'not'">一</h3>
                  <h3 :class="Serves.serveTimeInterval.indexOf('周二') > -1 ?  '' : 'not'">二</h3>
                  <h3 :class="Serves.serveTimeInterval.indexOf('周三') > -1 ?  '' : 'not'">三</h3>
                  <h3 :class="Serves.serveTimeInterval.indexOf('周四') > -1 ?  '' : 'not'">四</h3>
                  <h3 :class="Serves.serveTimeInterval.indexOf('周五') > -1 ?  '' : 'not'">五</h3>
                  <h3 :class="Serves.serveTimeInterval.indexOf('周六') > -1 ?  '' : 'not'">六</h3>
                  <h3 :class="Serves.serveTimeInterval.indexOf('周日') > -1 ?  '' : 'not'">日</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //帮助-->
        <!-- <div class="help-ct mt--30">
            <h2>帮助</h2>
            <ul>
              <li><a @click="$router.push('/about?type=1')">如何知道我的预订申请被对方接受？</a></li>
              <li><a @click="$router.push('/about?type=1')">预订金是什么，怎么支付？其余的费用又怎么支付？</a></li>
              <li><a @click="$router.push('/about?type=1')">我什么时候可以得到导游的联系方式？</a></li>
            </ul>
          </div> -->
      </div>
    </div>
  </div>
</template>


<!--JS-->
<script>
  import {
    insertServeOrder,
    selectUserServes,
    selectUserServesByCode
  } from '@/api/apis'
  export default {
    data() {
      return {
        startTimeData: [],
        nameNumber: '1',
        nameNumberSm: '0',
        timeData: '',
        remark: '',
        iphone: '',
        wechat: '',
        Serves: '',
        ServesList: '',
        setListData: [],
        serveNum: 1
      };
    },
    watch: {
      startTimeData(val) {
        let vm = this
        vm.setListData = []
        // 获取时间 天数
        let timeKey = ((val[1] / 1000) - (val[0] / 1000)) / 86400
        let dataNum = timeKey.toFixed(0)
        vm.timeData = Number(dataNum)
        for (let i = 0; i < vm.timeData; i++) {
          let text = {
            code: Number(vm.$route.query.service),
            text: ''
          }
          vm.setListData.push(text)
        }
      },
      setListData(val) {
        this.serveNum = val.length
      }
    },
    methods: {
      numChange(currentValue, oldValue) {
        console.log(currentValue, "当前")
        console.log(oldValue, "旧")
        if (currentValue > oldValue) {
          let num = currentValue - oldValue
          for (let i = 0; i < num; i++) {
            let text = {
              code: Number(this.$route.query.service),
              text: ''
            }
            this.setListData.push(text)
          }
        } else {
          let num = oldValue - currentValue
          this.setListData.splice(this.setListData.length-1, num)
        }
      },
      orderAdd() {
        let vm = this
        if (vm.iphone == '') {
          vm.$message.warning('请输入联系电话')
          return
        }
        // 提交
        insertServeOrder({
          servesCode: vm.$route.query.service,
          userCode: localStorage.getItem("pbw_user_pc_uid"),
          orderStart: vm.startTimeData[0] / 1000,
          orderEnd: vm.startTimeData[1] / 1000,
          serveNum: vm.setListData.length,
          servePeople: vm.nameNumber,
          telphone: vm.iphone,
          remark: vm.remark,
          orderPrice: 16,
          weChat: vm.wechat
        }).then((res) => {
          if (res.code == '000000') {
            vm.$router.push('/orderMoney?orderNum=' + res.data.serverNum)
          } else {
            vm.$message.warning(res.msg)
          }
        })
      },
      moneyCount() {
        let vm = this
        var money = 0
        if (vm.ServesList) {
          for (let item of vm.setListData) {
            for (let ser of vm.ServesList) {
              if (ser.code == item.code) {
                money += Number(ser.pushPrice)
              }
            }
          }
        }
        return money
      },
      textxGet(code) {
        let vm = this
        // 获取服务列表
        if (vm.ServesList) {
          for (let item of vm.ServesList) {
            if (item.code == code) {
              return item.pushTypeStr
            }
          }
        }
      },
      cityGet(code) {
        let vm = this
        // 获取服务列表
        if (vm.ServesList) {
          for (let item of vm.ServesList) {
            if (item.code == code) {
              return item.serveCityStr
            }
          }
        }
      },
      PriceNamGet(code) {
        let vm = this
        // 获取服务列表
        if (vm.ServesList) {
          for (let item of vm.ServesList) {
            if (item.code == code) {
              return item.servePriceName
            }
          }
        }
      },
      PriceGet(code) {
        let vm = this
        // 获取服务列表
        if (vm.ServesList) {
          for (let item of vm.ServesList) {
            if (item.code == code) {
              return item.pushPrice
            }
          }
        }
      },
      addList() {
        let vm = this
        let text = {
          code: Number(vm.$route.query.service),
          text: ''
        }
        vm.setListData.push(text)
      },
      delList(index) {
        this.setListData.splice(index, 1)
      },
      TimeDataBtn(e) {
      },
    },
    mounted() {
      let vm = this
    },
    created() {
      let vm = this
      vm.nameCode = vm.$route.query.nameCode
      // 人数
      vm.nameNumber = vm.$route.query.nameNumber
      // 获取服务信息
      selectUserServesByCode({
        code: Number(vm.$route.query.service),
        role: 2
      }).then((res) => {
        if (res.code == '000000') {
          vm.Serves = res.data
        } else {
          vm.$message.warning(res.msg)
        }
      })
      // 获取服务列表
      selectUserServes({
        userCode: vm.$route.query.nameCode,
        role: 2
      }).then((res) => {
        if (res.code == '000000') {
          vm.ServesList = res.data
        } else {
          vm.$message.warning(res.msg)
        }
      })
      // 赋值时间
      vm.startTimeData[0] = Number(vm.$route.query.startTime)
      vm.startTimeData[1] = Number(vm.$route.query.endTime)
      vm.nameNumber = Number(vm.$route.query.nameNumber)
      // 获取时间 天数
      let timeKey = (Number(vm.$route.query.endTime / 1000) - Number(vm.$route.query.startTime / 1000)) / 86400
      let dataNum = timeKey.toFixed(0)
      vm.timeData = Number(dataNum)
      for (let i = 0; i < vm.timeData; i++) {
        let text = {
          code: Number(vm.$route.query.service),
          text: ''
        }
        vm.setListData.push(text)
      }
      // Data,"初始")
    },
    filters: {
      time: function (value) {
        var time = new Date(value);
        function add0(m) {
          return m < 10 ? '0' + m : m
        }
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        var timeResult = add0(m) + '月' + add0(d)+ '日' + add0(h) + '时' + add0(mm)+ '分';
        if (timeResult == '1970-01-01' || timeResult == '1970-01-02') {
          return '--'
        } else {
          return timeResult
        }
      }
    },
    updated() {
    }
  };
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  .addList {
    padding: 20px;
    span {
      color: #f60;
      font-size: 16px;
      border: 1px solid #f60;
      padding: 2px 18px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
  .list_del {
    text-align: right;
    margin: 10px 30px 0 0;
    span {
      color: #f60;
      font-size: 16px;
      border: 1px solid #f60;
      padding: 2px 18px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
  .trip_info {
    margin-top: 50px;
  }
  .week {
    margin: 10px 10px;
    display: flex;
    justify-content: space-between;
    h3 {
      background: #f60;
      color: #fff;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .not {
      background: #ddd;
    }
  }
  /* ==== 预约流程(陪行) {{{ ==== */
  .sec_order_step {
    background: #eaeaea;
    height: 100px;
    box-shadow: 0 1px 3px rgba(50, 50, 50, 0.2);
    -webkit-box-shadow: 0 1px 3px rgba(50, 50, 50, 0.2);
    -moz-box-shadow: 0 1px 3px rgba(50, 50, 50, 0.2);
  }
  .sec_order_step .order-step-inner {
    text-align: center;
  }
  .sec_order_step .order-step-inner ul {
    display: inline-block;
    *display: inline;
    *zoom: 1;
  }
  .sec_order_step .order-step-inner ul li {
    display: inline-block;
    vertical-align: top;
    margin-top: 28px;
    height: 50px;
    width: 200px;
  }
  .sec_order_step .order-step-inner ul li span {
    color: #666;
    display: block;
    line-height: 22px;
  }
  .sec_order_step .order-step-inner ul li.on span {
    color: #f60;
  }
  .sec_order_step .order-step-inner ul li .s1 {
    font-size: 22px;
  }
  .sec_order_step .order-step-inner ul li .s2 {
    font-size: 15px;
    margin-top: 6px;
  }
  .sec_order_step .order-step-inner ul li.arrow {
    background: url(../../../static/images/icon-arrow-step.png) no-repeat center center;
    width: 10px;
  }
  /* }}} */
  /* 导游详细展示 */
  .sec_guide_container {
    margin-top: 30px;
  }
  .sec_guide_container .hd {
    background: url(../../../static/images/icon-arrow.png) no-repeat left center;
    border-top: 3px solid #cecece;
    color: #000;
    font-size: 24px;
    padding: 10px 0 10px 20px;
    line-height: 30px;
    position: relative;
  }
  .sec_guide_container .hd .favor {
    font-size: 18px;
    position: absolute;
    right: 15px;
  }
  .sec_guide_container .hd .favor img {
    margin-right: 10px;
    vertical-align: top;
    height: 30px;
    width: 30px;
  }
  /*(左侧)主体*/
  .sec_guide_container .lay-gd-main {
    width: 880px;
    position: relative;
  }
  .sec_guide_container .lay-gd-main2 {
    width: 760px;
    position: relative;
  }
  /*陪行预约流程(step02~step04)*/
  .pg-orderStep-zone h3.tit {
    color: #333;
    font-size: 16px;
  }
  .pg-orderStep-zone .cont {
    background: #fff;
    border: 1px solid #ddd;
    margin-top: 8px;
    margin-bottom: 30px;
  }
  .pg-orderStep-zone .split {
    margin: 0 3px;
    line-height: 30px;
    font-size: 16px;
    color: #f60
  }
  .pg-orderStep-zone .base_info .cont {
    padding: 25px 0 10px 15px;
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
  }
  .pg-orderStep-zone .base_info .row {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }
  .pg-orderStep-zone .base_info .row .lbl {
    float: left;
    color: #666;
    font-size: 14px;
    line-height: 30px;
    width: 100px;
  }
  .pg-orderStep-zone .base_info .row .ipt-text {
    background: url(../../../static/images/icon-datepicker-bg.png) no-repeat 95% center #fff;
    border: 1px solid #ccc;
    float: left;
    padding: 4px 5px;
    outline: none;
    height: 20px;
    line-height: 20px;
    width: 160px;
  }
  .pg-orderStep-zone .base_info .row .mem-amount {
    background: #fff;
    width: 125px;
    position: relative;
  }
  .pg-orderStep-zone .base_info .row .mem-children {
    margin-left: 140px;
  }
  .pg-orderStep-zone .base_info .row .mem-amount input {
    border: 1px solid #ccc;
    display: block;
    font: 14px/14px Arial;
    outline: none;
    padding: 8px 25px 8px 0;
    text-align: center;
    height: 14px;
    width: 40px;
    position: absolute;
    left: 30px;
    top: 1px;
  }
  .pg-orderStep-zone .base_info .row .mem-amount a {
    background: #f2f3f2;
    border: 1px solid #ccc;
    color: #666;
    display: block;
    font: bold 14px/30px Arial;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
    text-decoration: none;
    text-indent: 2px;
    height: 30px;
    width: 30px;
    position: absolute;
    top: 1px;
  }
  .pg-orderStep-zone .base_info .row .mem-amount a.btn-inc {
    right: 0;
    font-weight: 500;
  }
  .pg-orderStep-zone .base_info .row .mem-amount a.btn-dec {
    left: 1px;
  }
  .pg-orderStep-zone .base_info .row .mem-amount .tip {
    color: #aaa;
    font-size: 12px;
    font-weight: 500;
    position: absolute;
    top: 9px;
    right: 35px;
  }
  .pg-orderStep-zone .base_info .row .city_list {
    margin: 5px 0 10px;
  }
  .pg-orderStep-zone .base_info .row .city_list a {
    background: #f60;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    margin-right: 5px;
    padding: 0 10px;
  }
  .pg-orderStep-zone .base_info .row .city_add input {
    background: #fff;
    border: 1px solid #ccc;
    padding: 4px 5px;
    outline: none;
    height: 20px;
    line-height: 20px;
    width: 160px;
  }
  .pg-orderStep-zone .base_info .row .city_add span {
    color: #999;
    margin-left: 10px;
  }
  /*行程需求*/
  .pg-orderStep-zone .trip_info .cont {
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
  }
  .pg-orderStep-zone .trip_info .cont .col1 {
    float: left;
    width: 100px;
  }
  .pg-orderStep-zone .trip_info .cont .col2 {
    float: left;
    width: 150px;
    text-align: center;
  }
  .pg-orderStep-zone .trip_info .cont .col2 span {
    font-size: 20px;
    line-height: 45px;
  }
  .pg-orderStep-zone .trip_info .cont .col3 {
    float: left;
    width: 250px;
  }
  .pg-orderStep-zone .trip_info .cont .col4 {
    float: left;
    width: 250px;
  }
  .pg-orderStep-zone .trip_info .t_head {
    font-size: 15px;
    line-height: 50px;
    text-indent: 15px;
  }
  .pg-orderStep-zone .trip_info .t_body .t_row {
    float: left;
    border-top: 1px solid #eee;
    padding: 10px 0 30px;
    width: 100%;
  }
  .pg-orderStep-zone .trip_info .t_body .t_total {
    float: left;
    border-top: 1px solid #eee;
    text-align: right;
    padding: 10px 0 30px;
    width: 100%;
  }
  .pg-orderStep-zone .trip_info .t_body .t_total span {
    font-size: 30px;
    margin-right: 25px;
  }
  .pg-orderStep-zone .trip_info .t_body .col_collpse {
    height: 50px;
  }
  .pg-orderStep-zone .trip_info .t_body .col_collpse .fl {
    font-size: 15px;
    margin: 5px 0 0 15px;
    color: #f60;
    font-weight: bold;
    border: 1px solid #f60;
    padding: 1px 18px;
    border-radius: 10px;
  }
  .pg-orderStep-zone .trip_info .t_body .col_collpse .tag {
    background: url(../../../static/images/icon-label.png) no-repeat;
    color: #fff;
    display: block;
    font-size: 14px;
    margin-top: 3px;
    padding-left: 8px;
    height: 32px;
    z-index: 10;
  }
  .pg-orderStep-zone .trip_info .t_body .col_collpse .tag b {
    font-size: 18px;
    line-height: 18px;
  }
  .pg-orderStep-zone .trip_info .t_body .col_collpse .tag i {
    background: #f60;
    display: inline-block;
    padding: 0 10px;
    height: 32px;
    line-height: 32px;
  }
  .pg-orderStep-zone .trip_info .t_body .col1 {
    text-indent: 15px;
    font-size: 20px;
    line-height: 45px;
  }
  .pg-orderStep-zone .trip_info .t_body .col2 .searchable-select {
    min-width: 135px;
  }
  .pg-orderStep-zone .trip_info .t_body .col3 .searchable-select {
    min-width: 235px;
  }
  .pg-orderStep-zone .trip_info .t_body .searchable-select-holder {
    line-height: 30px;
  }
  .pg-orderStep-zone .trip_info .t_body .col4 textarea {
    font-size: 14px;
    color: #666666;
    background: #fff;
    border: 1px solid #ccc;
    padding: 5px;
    outline: none;
    overflow-y: auto;
    resize: none;
    height: 60px;
    line-height: 20px;
    width: 220px;
  }
  /*验证手机*/
  .pg-orderStep-zone .valid_tel .cont {
    background: none;
    border: none;
  }
  .pg-orderStep-zone .valid_tel .tips {
    color: #999;
    margin: 10px 0;
  }
  .pg-orderStep-zone .valid_tel .validCode .searchable-select {
    min-width: 150px;
  }
  .pg-orderStep-zone .valid_tel .validCode .searchable-select .searchable-select-holder {
    line-height: 30px;
  }
  .pg-orderStep-zone .valid_tel .validCode .ipt-text {
    color: #666;
    font-size: 18px;
    padding: 6px 6px;
    background: #fff;
    border: 1px solid #ddd;
    margin-left: -1px;
    outline: none;
    height: 20px;
    line-height: 20px;
    width: 180px;
  }
  .pg-orderStep-zone .valid_tel .validCode .sendCode {
    background: #08d1a1;
    border: 0;
    border-radius: 3px;
    color: #fff;
    font: 14px/30px "sans-serif";
    margin-left: 5px;
    text-align: center;
    height: 32px;
    width: 110px;
  }
  .pg-orderStep-zone .submit_order {
    margin-top: 50px;
  }
  .pg-orderStep-zone .submit_order .submit-btn {
    text-align: center;
    background: #f60;
    border: 1px solid #e08c00;
    border-radius: 3px;
    color: #fff;
    cursor: pointer;
    font-size: 18px;
    margin: 10px 0 0 2px;
    padding: 11px 0 12px;
    height: auto;
    width: 755px;
    box-shadow: 0 1px 2px rgba(50, 50, 50, 0.5);
    -webkit-box-shadow: 0 1px 2px rgba(50, 50, 50, 0.5);
    -moz-box-shadow: 0 1px 2px rgba(50, 50, 50, 0.5);
  }
  .lay-gd-side .i-service2 {
    margin-top: 0;
  }
  .i-service2 .service-ct .my-serv {
    margin-top: 0;
  }
  .i-service2 .service-ct .my-serv h2 {
    color: #333;
    font-size: 16px;
  }
  .i-service2 .service-ct .my-serv .ct {
    background: #fff;
    margin-top: 8px;
  }
  .i-service2 .service-ct .my-serv .ct .p1 {
    background: url(../../../static/images/icon-basic-serv.png) no-repeat left center;
    margin: 15px 0 0 15px;
    padding-left: 20px;
  }
  .i-service2 .service-ct .my-serv .ct .p2 {
    margin: 5px 0 0 34px;
  }
  /*侧边广告*/
  .lay-gd-side .i-service .serv-advert {
    margin: 0 auto;
    width: 342px;
  }
  .lay-gd-side .i-service .serv-advert img {
    max-width: 100%;
  }
  /*帮助*/
  .lay-gd-side .help-ct {
    border: 1px solid #ccc;
    margin: 0 auto;
    width: 340px;
  }
  .lay-gd-side .help-ct h2 {
    background: #eee;
    color: #333;
    font-size: 16px;
    padding: 10px;
  }
  .lay-gd-side .help-ct ul li {
    background: #fff;
    border-top: 1px solid #ddd;
    padding: 12px 10px;
  }
  .lay-gd-side .help-ct ul li a {
    color: #666;
    display: block;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 20px;
  }
  .lay-gd-side .help-ct ul li a:hover {
    color: #f60;
    text-decoration: underline;
  }
  /*(右侧)边栏*/
  .sec_guide_container .lay-gd-side {
    width: 360px;
  }
  .lay-gd-side .i-service {
    margin-top: 36px;
  }
  .lay-gd-side .i-service .service-ct {
    margin: 0 auto;
    width: 342px;
  }
  .i-service .service-ct ul {
    display: inline-block;
    margin-right: -15px;
  }
  .i-service .service-ct ul li {
    float: left;
    margin-right: 15px;
    width: 120px;
  }
  .i-service .service-ct ul li.last {
    width: 70px;
  }
  .i-service .service-ct ul li label {
    display: block;
    color: #999;
    font-size: 14px;
  }
  .i-service .service-ct ul li .ipt-text {
    background: url(../../../static/images/icon-datepicker-bg.png) no-repeat 95% center #fff;
    border: 1px solid #ddd;
    padding: 10px 5px;
    outline: none;
    height: 20px;
    line-height: 20px;
    width: 108px;
  }
  .i-service .service-ct ul li select {
    border: 1px solid #ddd;
    padding: 5px;
    height: 42px;
    width: 71px;
  }
  .i-service .service-ct .my-serv {
    margin-top: 15px;
  }
  .i-service .service-ct .my-serv h2 {
    color: #999;
    font-size: 12px;
  }
  .i-service .service-ct .my-serv .ct {
    border: 1px solid #ddd;
    color: #333;
    font-size: 12px;
    margin-top: 5px;
    height: 74px;
    width: 340px;
    position: relative;
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
  }
  .i-service .service-ct .my-serv .ct span {
    display: block;
    margin: 15px 40px 0 15px;
    word-break: break-all;
  }
  .i-service .service-ct .my-serv .ct span .pickup {
    background: url(../../../static/images/icon-pickup.png) no-repeat left center;
    color: #3d5480;
    padding-left: 22px;
  }
  .i-service .service-ct .my-serv .ct .close {
    background: url(../../../static/images/icon-close.png) no-repeat;
    height: 18px;
    width: 18px;
    position: absolute;
    top: 28px;
    right: 5px;
  }
  .i-service .service-ct .btn-bookNow {
    margin-top: 15px;
    text-align: center;
    height: 48px;
    line-height: 48px;
    width: 100%;
  }
  .i-service .service-ct .btn-bookNow a {
    background: #3d5480;
    border-radius: 2px;
    color: #fff;
    display: block;
    font-size: 18px;
  }
  .i-service .service-ct .btn-bookNow a:hover {
    background: #526a98;
  }
  .i-service .service-ct .process {
    border: 1px solid #ddd;
    float: left;
    margin-top: 20px;
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
  }
  .i-service .service-ct .process span {
    background: #fff;
    display: inline;
    float: left;
    padding-bottom: 8px;
    text-align: center;
    width: 85px;
  }
  .i-service .service-ct .process span i {
    background: url(../../../static/images/icon-big-cicle.png) no-repeat center;
    color: #fff;
    display: block;
    font-size: 14px;
    font-weight: 700;
    margin: 0 auto;
    padding-top: 20px;
    height: 38px;
    width: 38px;
  }
  /**/
</style>



// WEBPACK FOOTER //
// src/views/order/orderAdd.vue